var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-menu"},[_c('span',{staticClass:"sandwich",class:{ active: _vm.active }},[_c('span',{staticClass:"sw-topper"}),_c('span',{staticClass:"sw-bottom"}),_c('span',{staticClass:"sw-footer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }